import { Button, Grid, TextField } from '@mui/material';
import React, { useState, useContext } from 'react';
import styles from './styles.module.css';
import CloseIcon from '@mui/icons-material/Close';
import WarehouseService from 'services/WarehouseService';
import { DialogActions } from '@mui/material';
import { AlertMessagesContext } from 'react-alert-messages';
import Loader from 'components/utils/Loading';
import { useTranslation } from 'react-i18next';

export default function EditWarehouseDialog(props) {
  const { closeDialog, editData, reloadWarehouses } = props;
  const { postAlertMessage } = useContext(AlertMessagesContext);
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');

  const [name, setName] = useState(editData.name || '');
  const [loadingIndicator, setLoadingIndicator] = useState(false);

  const handleUpdateWarehouse = async () => {
    const data = {
      name,
    };
    setLoadingIndicator(true);
    try {
      await WarehouseService.updateWarehouse(editData.id, data);
      postAlertMessage({
        text: tPopup('Warehouse updated successfully'),
        type: 'success',
      });
      reloadWarehouses();
      closeDialog();
    } catch (error) {
      postAlertMessage({ text: error.message, type: 'failed' });
    }
    setLoadingIndicator(false);
  };

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <Loader isOpen={loadingIndicator} />
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{tCommon('Edit Warehouse')}</h2>
          <CloseIcon onClick={closeDialog} />
        </div>
        <div className={styles.inputSec}>
          <Grid container alignItems="flex-start" spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label={tCommon('Warehouse ID')}
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={editData.id}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label={tCommon('Warehouse Name')}
                variant="outlined"
                size="small"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                fullWidth
                required
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.footSec}>
          <DialogActions>
            <Button variant="contained" color="secondary" size="small" onClick={closeDialog}>
              {tCommon('Close')}
            </Button>
            <Button
              variant="contained"
              size="small"
              color="primary"
              disabled={name === '' || loadingIndicator}
              onClick={handleUpdateWarehouse}
            >
              {tCommon('Update Warehouse')}
            </Button>
          </DialogActions>
        </div>
      </div>
    </div>
  );
}
